

/** imported components

    * ./svg => imported for all svg elements  
    * ./styles => imported for using of all created styled components.
    * useState, useEffect ===> React hooks (useState is a way to get/set value)

**/

import React, { useState, useEffect } from 'react';
import {
    WalkthroughContainer,WalkthroughWrapper,
    WalkthroughCard,
    WalkSection,
    WalkTopRow,
    WalkTopLeftCol,WalkTopRightCol,WalkMidRow,
    WalkFooter,WalkFooterLeftCol,WalkFooterRightCol,
    DotsSection,ButtonWrapper
    
} from './styles';


export const HomePageWalkthroughView = (props) => {
    const { activeSlide, setActiveSlide } = props;
    var highlightarea1 = document.querySelector('.walk-1');
    var highlightarea2 = document.querySelector('.walk-2');
    var highlightarea3 = document.querySelector('.ng-sidebar');
    var highlightarea4 = document.querySelector('.add-plant-svg');
    var highlightarea5 = document.querySelector(".resource-tab");
    var referHighlightarea = document.querySelector(".refer-walk");
    const users = JSON.parse(localStorage.getItem("userData"));
    const group_id = users ? users.group_id:''; /*if 14 it's simple user else 2 or 11 for admin*/
    const UserName = users ? users.name : "First Name";
    // Function to navigate slider from one to next
    const HandleSlider = (val) => {
        setActiveSlide(val);
    }
    const handleClose = () => {
        setActiveSlide(null);
        highlightarea1?.classList.remove('walkthrough-active');
        highlightarea2?.classList.remove('walkthrough-active');
        document.querySelector('.training-main-wrapper').classList.remove('walkthrough-active');
        document.querySelector('.training-main-wrapper').classList.remove('mobile-walkthrough-active');
        highlightarea3?.classList.remove('active');
        highlightarea3?.classList.remove('mobile-active');
        highlightarea4?.classList.remove('walkthrough-active');
        highlightarea5?.classList.remove('walkthrough-active');
        referHighlightarea?.classList.remove('active');
        // document.querySelector('.unitar-resource-pop-wrapper').classList.remove('active-min-class');
        props.closeFunction();
    }
    
    useEffect(() => {
        // main container background
        document.querySelector('.training-main-wrapper').classList.add('walkthrough-active');
        var highlightarea1 = document.querySelector('.walk-1');
        var highlightarea2 = document.querySelector('.walk-2');
        var highlightarea3 = document.querySelector('.ng-sidebar');
        var highlightarea4 = document.querySelector('.add-plant-svg');
        var highlightarea5 = document.querySelector(".resource-tab");
        // code to set position
        var asset = document.querySelector('.assets-wrapper');
        let sidebar_list = document.querySelector('.ng-level1-nav-list-wrapper')?.getBoundingClientRect().top;
        let add_tab = document.querySelector('.add-plant-svg')?.getBoundingClientRect().top;
        let resource_tab = document.querySelector('.resource-tab')?.getBoundingClientRect().top;
        let container1 = document.querySelector('.container-1');
        let container2 = document.querySelector('.container-2');
        let container3 = document.querySelector('.container-3');
        let container4 = document.querySelector('.container-4');
        let container5 = document.querySelector('.container-5');
        let training_wrapper = document.querySelector('.training-content');
        var referHighlightarea = document.querySelector(".refer-walk");
         
        if(container1 && sidebar_list ){
            container1.style.top = sidebar_list - 20 + 'px';
        }
        if(container5 && sidebar_list ){
            container5.style.top = sidebar_list - 5 + 'px';
        }
        // if(container2 && asset){
        //     asset.style.minHeight = '100vh';
        //     training_wrapper.scrollTop = container2?.getBoundingClientRect().height;
        //     container2.style.top = asset?.getBoundingClientRect().top - 20 + 'px';
        // }
        // else{
        //     training_wrapper.scrollTop = 0;
        //     asset.style.minHeight = 'auto';
        // }
        // if(container3 && asset){
        //     asset.style.minHeight = '100vh';
        //     training_wrapper.scrollTop = container3?.getBoundingClientRect().height;
        //     container3.style.top = asset?.getBoundingClientRect().top - 20 + 'px';
        // }
        if(container4 && resource_tab){
            container4.style.top = resource_tab - 20 + 'px';
        }
        if (activeSlide === 2) {
            referHighlightarea?.classList.add('active');
            highlightarea3?.classList.remove('active');
            if(window.innerWidth <= 740){
                highlightarea3?.classList.remove('mobile-active');
            }
        }
        else{
            referHighlightarea?.classList.remove('active');
            highlightarea3?.classList.remove('active');
            if(window.innerWidth <= 740){
                highlightarea3?.classList.remove('mobile-active');
            }
        }
        
        
        if (activeSlide === 3) {
            highlightarea1?.classList.add('walkthrough-active');
            highlightarea3?.classList.remove('active');
            if(window.innerWidth <= 740){
                highlightarea3?.classList.remove('mobile-active');
            }
        }
        else{
            highlightarea1?.classList.remove('walkthrough-active');
            highlightarea3?.classList.remove('active');
            if(window.innerWidth <= 740){
                highlightarea3?.classList.remove('mobile-active');
            }
        }
        // if (activeSlide === 3) {
        //     highlightarea2?.classList.add('walkthrough-active');
        //     highlightarea3?.classList.remove('active');
        // }
        // else{
        //     highlightarea2?.classList.remove('walkthrough-active');
        //     highlightarea3?.classList.remove('active');
        // }
        // if (activeSlide === 4) {
        //     highlightarea4?.classList.add('walkthrough-active');
        //     highlightarea3?.classList.remove('active');
        // }
        // else{
        //     highlightarea4?.classList.remove('walkthrough-active'); 
        //     highlightarea3?.classList.remove('active');
        // }
        if (activeSlide === 4) {
            highlightarea5?.classList.add('walkthrough-active');
            highlightarea3?.classList.add('active');
            if(window.innerWidth <= 740){
                highlightarea3?.classList.add('mobile-active');
                document.querySelector('.training-main-wrapper').classList.add('mobile-walkthrough-active');
            }
            else{
                document.querySelector('.training-main-wrapper').classList.remove('mobile-walkthrough-active');
            }
        }
        else{
            highlightarea5?.classList.remove('walkthrough-active');
            document.querySelector('.training-main-wrapper').classList.remove('mobile-walkthrough-active');
        }
        // if(window.innerWidth <= 740){
        //     document.querySelector('.unitar-resource-pop-wrapper').classList.add('active-min-class');
        // }
        // else{
        //     document.querySelector('.unitar-resource-pop-wrapper').classList.remove('active-min-class');
        // }
    }, [activeSlide]);

    return (
        <>
            
                <ShowContent active={activeSlide} item={1} >
                    <WalkthroughContainer data-component='WalkthroughContainer' style={{"display":"block"}} >
                        <WalkthroughWrapper data-component="WalkthroughWrapper">
                            <WalkthroughCard data-component="WalkthroughCard">
                                    <WalkSection data-component="WalkSection">
                                        <WalkTopRow data-component="WalkTopRow">
                                            <WalkTopLeftCol data-component="WalkTopLeftCol">
                                                <span>1 of 4 </span>
                                            </WalkTopLeftCol>
                                            <WalkTopRightCol data-component="WalkTopRightCol">
                                            <span className="img" onClick={() => handleClose()}>
                                                    <i className='close-icon' dangerouslySetInnerHTML={{ __html: crossSvg }}></i>
                                                </span>
                                            </WalkTopRightCol>
                                        </WalkTopRow>
                                        <WalkMidRow data-component="WalkMidRow">
                                            <h2>Welcome <span>{UserName}</span>,</h2>
                                            <p>This is your homepage. Here you can easily access your trainings and assets.</p>
                                        </WalkMidRow>
                                        <WalkFooter data-component="WalkFooter">
                                            <WalkFooterLeftCol data-component="WalkFooterLeftCol">
                                                <DotsSection data-component="DotsSection">        
                                                    <button className="circle" onClick={() => { HandleSlider(1) }} disabled={activeSlide === 1 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(2) }} disabled={activeSlide === 2 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(3) }} disabled={activeSlide === 3 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(4) }} disabled={activeSlide === 4 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                </DotsSection>
                                            </WalkFooterLeftCol>
                                            <WalkFooterRightCol data-component="WalkFooterRightCol">
                                                <ButtonWrapper data-component="ButtonWrapper">
                                                    <button className="btn-link" onClick={() => handleClose()}>
                                                        No thanks
                                                    </button>
                                                    <button className="solid-btn-link start" onClick={() => setActiveSlide(2)}>
                                                        Let’s go
                                                    </button>
                                                </ButtonWrapper>
                                            </WalkFooterRightCol>
                                        </WalkFooter>
                                    </WalkSection>
                            </WalkthroughCard>
                        </WalkthroughWrapper>
                    </WalkthroughContainer>
                </ShowContent>
                <ShowContent active={activeSlide} item={2}>
                    <WalkthroughContainer data-component='WalkthroughContainer' style={{"display":"block"}} >
                        <WalkthroughWrapper data-component="WalkthroughWrapper" className='container-5'>
                            <WalkthroughCard data-component="WalkthroughCard" className="tooltip-class right-tooltip">
                                    <WalkSection data-component="WalkSection">
                                        <WalkTopRow data-component="WalkTopRow">
                                            <WalkTopLeftCol data-component="WalkTopLeftCol">
                                                <span>2 of 4</span>
                                            </WalkTopLeftCol>
                                            <WalkTopRightCol data-component="WalkTopRightCol">
                                            <span className="img" onClick={() => handleClose()}>
                                                    <i className='close-icon' dangerouslySetInnerHTML={{ __html: crossSvg }}></i>
                                                </span>
                                            </WalkTopRightCol>
                                        </WalkTopRow>
                                        <WalkMidRow data-component="WalkMidRow">
                                            <h2>Refer a Colleague</h2>
                                            <p>Take the Skills Assessment and share it with your colleagues and friends. 
                                                Recommend the Smarterchains Learning Platform and provide acess to its 
                                                content to more people in your team, company and network</p>
                                        </WalkMidRow>
                                        <WalkFooter data-component="WalkFooter">
                                            <WalkFooterLeftCol data-component="WalkFooterLeftCol">
                                                <DotsSection data-component="DotsSection">        
                                                    <button className="circle" onClick={() => { HandleSlider(1) }} disabled={activeSlide === 1 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(2) }} disabled={activeSlide === 2 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(3) }} disabled={activeSlide === 3 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(4) }} disabled={activeSlide === 4 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                </DotsSection> 
                                            </WalkFooterLeftCol>
                                            <WalkFooterRightCol data-component="WalkFooterRightCol">
                                                <ButtonWrapper data-component="ButtonWrapper">
                                                    <button className="btn-link" onClick={() => setActiveSlide(1)}>
                                                        Previous
                                                    </button>
                                                    <button className="solid-btn-link" onClick={() => setActiveSlide(3)}>
                                                        Next
                                                    </button>
                                                </ButtonWrapper>
                                            </WalkFooterRightCol>
                                        </WalkFooter>
                                    </WalkSection>
                            </WalkthroughCard>
                        </WalkthroughWrapper>
                    </WalkthroughContainer>
                </ShowContent>
                <ShowContent active={activeSlide} item={3}>
                    <WalkthroughContainer data-component='WalkthroughContainer' style={{"display":"block"}} >
                        <WalkthroughWrapper data-component="WalkthroughWrapper" className='container-1'>
                            <WalkthroughCard data-component="WalkthroughCard" className="tooltip-class">
                                    <WalkSection data-component="WalkSection">
                                        <WalkTopRow data-component="WalkTopRow">
                                            <WalkTopLeftCol data-component="WalkTopLeftCol">
                                                <span>3 of 4</span>
                                            </WalkTopLeftCol>
                                            <WalkTopRightCol data-component="WalkTopRightCol">
                                            <span className="img" onClick={() => handleClose()}>
                                                    <i className='close-icon' dangerouslySetInnerHTML={{ __html: crossSvg }}></i>
                                                </span>
                                            </WalkTopRightCol>
                                        </WalkTopRow>
                                        <WalkMidRow data-component="WalkMidRow">
                                            <h2>IR 4.0 Training Courses</h2>
                                            <p>Here you can find all your trainings. Start with the Skills Assessment and 
                                                UPGRADE to access the Industry 4.0 Dimension Training to get Certfified</p>
                                        </WalkMidRow>
                                        <WalkFooter data-component="WalkFooter">
                                            <WalkFooterLeftCol data-component="WalkFooterLeftCol">
                                                <DotsSection data-component="DotsSection">        
                                                    <button className="circle" onClick={() => { HandleSlider(1) }} disabled={activeSlide === 1 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(2) }} disabled={activeSlide === 2 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(3) }} disabled={activeSlide === 3 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(4) }} disabled={activeSlide === 4 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                </DotsSection> 
                                            </WalkFooterLeftCol>
                                            <WalkFooterRightCol data-component="WalkFooterRightCol">
                                                <ButtonWrapper data-component="ButtonWrapper">
                                                    <button className="btn-link" onClick={() => setActiveSlide(2)}>
                                                        Previous
                                                    </button>
                                                    <button className="solid-btn-link" onClick={() => setActiveSlide(4)}>
                                                        Next
                                                    </button>
                                                </ButtonWrapper>
                                            </WalkFooterRightCol>
                                        </WalkFooter>
                                    </WalkSection>
                            </WalkthroughCard>
                        </WalkthroughWrapper>
                    </WalkthroughContainer>
                </ShowContent>
                <ShowContent active={activeSlide} item={4}>
                    <WalkthroughContainer data-component='WalkthroughContainer' style={{"display":"block"}} >
                        <WalkthroughWrapper data-component="WalkthroughWrapper" className='container-4'>
                            <WalkthroughCard data-component="WalkthroughCard" className="tooltip-class">
                                    <WalkSection data-component="WalkSection">
                                        <WalkTopRow data-component="WalkTopRow">
                                            <WalkTopLeftCol data-component="WalkTopLeftCol">
                                                <span>4 of 4</span>
                                            </WalkTopLeftCol>
                                            <WalkTopRightCol data-component="WalkTopRightCol">
                                            <span className="img" onClick={() => handleClose()}>
                                                    <i className='close-icon' dangerouslySetInnerHTML={{ __html: crossSvg }}></i>
                                                </span>
                                            </WalkTopRightCol>
                                        </WalkTopRow>
                                        <WalkMidRow data-component="WalkMidRow">
                                            <h2>Resource Center</h2>
                                            <p>Here you can find all the resources you will need. From case studies and methodology to product trainings.</p>
                                        </WalkMidRow>
                                        <WalkFooter data-component="WalkFooter">
                                            <WalkFooterLeftCol data-component="WalkFooterLeftCol">
                                                <DotsSection data-component="DotsSection">        
                                                    <button className="circle" onClick={() => { HandleSlider(1) }} disabled={activeSlide === 1 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(2) }} disabled={activeSlide === 2 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(3) }} disabled={activeSlide === 3 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                    <button className="circle" onClick={() => { HandleSlider(4) }} disabled={activeSlide === 4 ? true : false}>
                                                        <i className='close-icon' dangerouslySetInnerHTML={{ __html: circleSvg }}></i>
                                                    </button>
                                                </DotsSection> 
                                            </WalkFooterLeftCol>
                                            <WalkFooterRightCol data-component="WalkFooterRightCol">
                                                <ButtonWrapper data-component="ButtonWrapper">
                                                    <button className="btn-link" onClick={() => setActiveSlide(1)}>
                                                        Restart
                                                    </button>
                                                    <button className="solid-btn-link start" onClick={() => handleClose()}>
                                                        Let’s Start
                                                    </button>
                                                </ButtonWrapper>
                                            </WalkFooterRightCol>
                                        </WalkFooter>
                                    </WalkSection>
                            </WalkthroughCard>
                        </WalkthroughWrapper>
                    </WalkthroughContainer>
                </ShowContent>
                
            
            {/* MainWrapper ended */}
        </>
    );
}

// Function to show content
const ShowContent = (props) => {
    return (
      <>
        {props.active === props.item &&
          <>
            {props.children}
          </>
        }
      </>
    )
  }

  // Walkthrough SVG

const crossSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 7.33333C5.63181 6.96514 5.63181 6.36819 6 6C6.36819 5.63181 6.96514 5.63181 7.33333 6L18 16.6667C18.3682 17.0349 18.3682 17.6318 18 18C17.6318 18.3682 17.0349 18.3682 16.6667 18L6 7.33333Z" fill="#118ACB"/>
<path d="M6 18C5.63181 17.6318 5.63181 17.0349 6 16.6667L16.6667 6C17.0349 5.63181 17.6318 5.63181 18 6C18.3682 6.36819 18.3682 6.96514 18 7.33333L7.33333 18C6.96514 18.3682 6.36819 18.3682 6 18Z" fill="#118ACB"/>
</svg>
`
const circleSvg = `<svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="2" cy="2" r="2" fill="#C4C4C4"/>
</svg>   
`

